const Radio = {
  baseStyle: {},
  variants: {
    input: {
      container: {
        border: '1px solid #C0C4C4',
        h: '40px',
        borderRadius: 'md',
        px: '16px',
        py: '10px',
        _checked: {
          borderColor: 'primary',
        },
      },
    },
  },
}

export default Radio
